import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
    return (
        <nav className="navbar">
            <ul className="navbar-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/software">Software</Link></li>
                <li><Link to="/art">Art</Link></li>
                <li><Link to="/gamedev">Gamedev</Link></li>
                <li><Link to="/guides">Guides</Link></li>
            </ul>
        </nav>
    );
};

export default Navbar;
